import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { saveAs } from 'file-saver'
import { withTranslation } from 'react-i18next'

import { ReactComponent as DownloadIcon } from '../../assets/images/icons/i-download-16-16.svg'
import Button from '../Common/Buttons/Button/Button'
import Modal from '../Common/Modal/Modal'

import { imageConvertAction, deleteImage } from '../../store/actions/image.actions'
import { clearSettings, setImageStatus } from '../../store/actions/settings.actions'
import { showLoader, hideLoader } from '../../store/actions/loader.actions'

import { sendMetric } from '../../helpers/metric'
import { downloadImage } from '../../helpers/downloadImage' 

class Download extends Component {
  static propTypes = {
    imageData: PropTypes.object,
    imageSrc: PropTypes.string.isRequired,
    settingsList: PropTypes.array.isRequired,
    currentSettingId: PropTypes.number.isRequired,
    imageName: PropTypes.string.isRequired,
    imageFormat: PropTypes.string.isRequired,
    imageSize: PropTypes.number.isRequired,
    dispatchDeleteImage: PropTypes.func.isRequired,
    dispatchImageConvert: PropTypes.func.isRequired,
    imageToDownload: PropTypes.string.isRequired,
    canvas: PropTypes.object.isRequired,
    dispatchClearSettings: PropTypes.func.isRequired,
    dispatchShowLoader: PropTypes.func.isRequired,
    dispatchHideLoader: PropTypes.func.isRequired,
    dispatchSetImageStatus: PropTypes.func.isRequired,
    isChangesModalOpen: PropTypes.bool.isRequired,
    onChangesModalClose: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    i18n: PropTypes.any,
  }

  constructor(props) {
    super(props)

    this.state = {
      imageWidth: 0,
      imageHeight: 0,
    }

    this.canvasRef = React.createRef()
  }

  applyChanges = () => {
    const {
      settingsList,
      currentSettingId,
      imageFormat,
      dispatchImageConvert,
      dispatchShowLoader,
      imageData,
    } = this.props
    
    dispatchShowLoader()

    const { base64, newImageData } = downloadImage({ imageData, settingsList, currentSettingId })

    dispatchImageConvert({ format: imageFormat, image: base64})
    this.setState({ imageWidth: newImageData.width, imageHeight: newImageData.height })
  }

  componentDidUpdate(prevProps) {
    const {
      imageWidth,
      imageHeight
    } = this.state
    const {
      imageToDownload,
      imageName,
      imageFormat,
      dispatchHideLoader,
      imageSize,
      dispatchSetImageStatus
    } = this.props

    if (prevProps.imageToDownload !== imageToDownload && imageToDownload.length > 0) {
      saveAs(process.env.REACT_APP_API_URL + imageToDownload, `${imageName}.${imageFormat}`)

      dispatchSetImageStatus()

      sendMetric({
        event: 'DOWNLOAD_BUTTON_CLICKED',
        gtm: {
          eventCategory: 'Conversions',
          eventAction: 'click',
          eventLabel: 'DOWNLOAD_BUTTON_CLICKED'
        },
        amplitude: {
          OUTPUT_FILE_EXTENSION: imageFormat,
          OUTPUT_FILE_WIDTH: imageWidth,
          OUTPUT_FILE_HEIGHT: imageHeight,
          OUTPUT_FILE_RESOLUTION: `${imageWidth}x${imageHeight}`,
          OUTPUT_FILE_SIZE: imageSize,
        }
      })

      dispatchHideLoader()
    }
  }

  onDownloadFile = () => {
    const { imageSrc, onChangesModalClose } = this.props
    if (!imageSrc) return

    onChangesModalClose()

    this.applyChanges()
  }

  onCloseChangesModal = () => {
    const { dispatchSetImageStatus, onChangesModalClose } = this.props

    dispatchSetImageStatus()
    onChangesModalClose(true)
  }

  render() {
    const { 
      imageSrc, 
      isChangesModalOpen, 
      t 
    } = this.props

    return (
      <div className="download">
        <Button
          variant="icon-text"
          disabled={!imageSrc}
          onClick={this.onDownloadFile}
        >
          <DownloadIcon />
          {t('download.button')}
        </Button>
        <canvas className="download__canvas" ref={this.canvasRef} />
        <Modal isOpen={isChangesModalOpen} onCloseModal={this.onCloseChangesModal}>
          <div className="modal__body">{t('modals.image-download')}</div>
          <div className="modal__buttons">
            <Button onClick={this.onDownloadFile}>
              {t('buttons.download')}
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = ({
  imageStore: { imageSrc, imageData, imageName, imageFormat, imageToDownload, imageSize },
  settingsStore: { settingsList, currentSettingId },
  canvasStore: { canvas },
  loaderStore: { message }
}) => ({
  imageSrc,
  imageData,
  imageFormat,
  imageName,
  imageToDownload,
  imageSize,
  settingsList,
  currentSettingId,
  canvas,
  message
})
const mapDispatchToProps = (dispatch) => ({
  dispatchImageConvert: (data) => dispatch(imageConvertAction({ data })),
  dispatchDeleteImage: () => dispatch(deleteImage()),
  dispatchClearSettings: () => dispatch(clearSettings()),
  dispatchShowLoader: (message) => dispatch(showLoader(message)),
  dispatchHideLoader: () => dispatch(hideLoader()),
  dispatchSetImageStatus: () => dispatch(setImageStatus()),
})

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Download)
)
